import { plainLinkPath, socialIconFor, socialIcons } from "../../src/lib/social-icons";

type Social = { label: string; url: string };

/** The creator's social links as their networks' marks, or a plain link mark for anything else. */
export function SocialLinks({
  socials,
  className,
  label = "Social links",
}: {
  socials: readonly Social[];
  className?: string;
  label?: string;
}) {
  if (!socials.length) return null;
  return (
    <nav className={["social-links", className].filter(Boolean).join(" ")} aria-label={label}>
      {socials.map((item) => {
        const icon = socialIconFor(item.url, item.label);
        const name = icon ? socialIcons[icon].title : item.label;
        return (
          <a
            key={item.url}
            href={item.url}
            target="_blank"
            rel="noopener noreferrer me"
            aria-label={name}
            title={name}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
              {icon ? (
                <path d={socialIcons[icon].path} fill="currentColor" />
              ) : (
                <path
                  d={plainLinkPath}
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.75"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              )}
            </svg>
          </a>
        );
      })}
    </nav>
  );
}
